import api from '@/api/job'

const state = {}

const actions = {
  getJobQrCode ({ commit }, { jobId, shareUrl }) {
    return api.getJobQrCode(jobId, shareUrl)
  },
  countShareTimes ({ commit }, params) {
    return api.countShareTimes(params)
  },
  getJobLocations ({ commit }, { jobId, jobInfo }) {
    return api.getJobLocations(jobId, jobInfo)
  },
  getSubmitInfoEncrypt ({ commit }, params) {
    return api.getSubmitInfoEncrypt(params)
  },
  getReferralEarnRewards ({ commit }, url) {
    return api.getReferralEarnRewards(url)
  },
  searchCompanyJobList ({ commit }, params) {
    return api.searchCompanyJobList(params)
  },
  getCurrentCityByIp ({ commit }) {
    return api.getCurrentCityByIp()
  },
  getWorkLocationCitys ({ commit }, languageCode) {
    return api.getWorkLocationCitys(languageCode)
  },
  getSonIndustry ({ commit }) {
    return api.getSonIndustry()
  },
  getSonIndustryById ({ commit }, industryId) {
    return api.getSonIndustryById(industryId)
  },
  getParentIndustry ({ commit }) {
    return api.getParentIndustry()
  },
  getJobRegions ({ commit }, cityId) {
    return api.getJobRegions(cityId)
  },
  getJobAreas ({ commit }, regionId) {
    return api.getJobAreas(regionId)
  },
  unFollowCompany ({ commit }, companyId) {
    return api.unFollowCompany(companyId)
  },
  getJobDetailJobPoster ({ commit }, params) {
    return api.getJobDetailJobPoster(params)
  },
  getJobDetailInfoByShortId ({ commit }, { shortId, params }) {
    return api.getJobDetailInfoByShortId(shortId, params)
  },
  getJobReferralSetting ({ commit }, params) {
    return api.getJobReferralSetting(params)
  },
  getJobApplyStatus ({ commit }, params) {
    return api.getJobApplyStatus(params)
  },
  getJobApplyAgreementInfo ({ commit }, params) {
    return api.getJobApplyAgreementInfo(params)
  },
  getJobIndustryListWithJobType (context) {
    return api.getJobIndustryListWithJobType()
  },
  getJobSalaryList (context) {
    return api.getJobSalaryList()
  },
  getJobExperienceList (context) {
    return api.getJobExperienceList()
  },
  getJobWorkTimeList (context) {
    return api.getJobWorkTimeList()
  },
  addPotentialCandidates ({ commit }, params) {
    return api.addPotentialCandidates(params)
  },
  getJobListForPC ({ commit }, params) {
    return api.getJobListForPC(params)
  },
  getJobListFilter ({ commit }, params) {
    return api.getJobListFilter(params)
  },
  getJobChannelAdditionalInfo ({ commit }, params) {
    return api.getJobChannelAdditionalInfo(params)
  },
  getJobCustomDescription ({ commit }, params) {
    return api.getJobCustomDescription(params)
  },
  getTargetJobList (context, params) {
    return api.getTargetJobList(params)
  },
  getJobInfo (context, { jobId, params }) {
    return api.getJobInfo(jobId, params)
  },
  getJobIdList (context, params) {
    return api.getJobIdList(params)
  },
  getJobCriterionList (context, params) {
    return api.getJobCriterionList(params)
  },
  createJobCriterion (context, params) {
    return api.createJobCriterion(params)
  },
  updateJobCriterion (context, params) {
    return api.updateJobCriterion(params)
  },
  createJobCriterionByParseJob (context, params) {
    return api.createJobCriterionByParseJob(params)
  },
  calculateJobCriterion (context, params) {
    return api.calculateJobCriterion(params)
  }
}

const mutations = {
}

const getters = {
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
